import {FeatureId} from '@client/constants/features';

const accountTypeFeatureMap = {
  [FeatureId.INDIVIDUAL]: {
    accountTypeName: 'Individual',
    accountTypeId: 3,
  },
  [FeatureId.TRADITIONAL_IRA]: {
    accountTypeName: 'Traditional IRA',
    accountTypeId: 2,
  },
  [FeatureId.ROTH_IRA]: {
    accountTypeName: 'Roth IRA',
    accountTypeId: 1,
  },
  [FeatureId.SEP_IRA]: {
    accountTypeName: 'SEP IRA',
    accountTypeId: 13,
  },
  [FeatureId.SIMPLE_IRA]: {
    accountTypeName: 'SIMPLE IRA',
    accountTypeId: 14,
  },
};

export default class AccountSettings {
  constructor() {
    this.showWealthProjection = null;
    this.showCurrentPortfolio = null;
    this.showTargetPortfolio = null;
    this.canOpen = null;
    this.showTotalCash = null;
    this.availableAccountTypes = [];
  }

  loadData(payload) {
    this.canOpen = payload.find((setting) => setting.id === FeatureId.OPEN_ACCOUNT)?.value;
    this.showTotalCash = payload.find((setting) => setting.id === FeatureId.TOTAL_ACCOUNTS_CASH_BOX)?.value;
    this.showWealthProjection = payload.find((setting) => setting.id === FeatureId.WEALTH_PROJECTION_ACCOUNT)?.value;
    this.showCurrentPortfolio = payload.find((setting) => setting.id === FeatureId.CURRENT_PORTFOLIO_ACCOUNT)?.value;
    this.showTargetPortfolio = payload.find((setting) => setting.id === FeatureId.TARGET_PORTFOLIO_ACCOUNT)?.value;

    // Loop through the account type features and gather a list of all enabled account types the client can choose from.
    // eslint-disable-next-line unicorn/no-array-reduce
    this.availableAccountTypes = payload.reduce((accountTypes, feature) => {
      const accountType = accountTypeFeatureMap[feature.id];

      // eslint-disable-next-line unicorn/prefer-spread
      return accountType && feature.value ? accountTypes.concat(accountType) : accountTypes;
    }, []);
  }
}
